import secondaryComponents from "../../../../../components/secondaryComponents";
import { ServiceForm } from "../../../../../components/secondaryComponents/products";

const CreateService = () => {
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Service"
      description="Create service"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <ServiceForm />
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default CreateService;
